module.exports = __webpack_public_path__ + "img/ch-protection.bdc4dc44.jpg";